<!-- <app-header *ngIf="currentUser"></app-header> -->

<app-header></app-header>
<section class="padding-bottom">
    <router-outlet></router-outlet>
</section>

<footer class="footer-area">
    <!--== Start Footer Main ==-->
    <div class="footer-main">
        <div class="container pt--0 pb--0">
            <div class="row">
                <div class="col-md-6 col-lg-3">
                    <!--== Start widget Item ==-->
                    <div class="widget-item">
                        <div class="about-widget-wrap">
                            <div class="widget-logo-area">
                                <a href="index.html">
                                    <img class="logo-main" src="https://dnj.shivamitconsultancy.com/Content/vidya-sury-faith1.gif" width="131" height="34"
                                        alt="Logo" />
                                </a>
                            </div>
                            <p class="desc">Lorem ipsum dolor sit amet consl adipisi elit, sed do eiusmod templ
                                incididunt ut labore</p>
                            <div class="social-icons">
                                <a href="https://www.facebook.com/" target="_blank" rel="noopener"><i
                                        class="fa fa-facebook"></i></a>
                                <a href="https://dribbble.com/" target="_blank" rel="noopener"><i
                                        class="fa fa-dribbble"></i></a>
                                <a href="https://www.pinterest.com/" target="_blank" rel="noopener"><i
                                        class="fa fa-pinterest-p"></i></a>
                                <a href="https://twitter.com/" target="_blank" rel="noopener"><i
                                        class="fa fa-twitter"></i></a>
                            </div>
                        </div>
                    </div>
                    <!--== End widget Item ==-->
                </div>
                <div class="col-md-6 col-lg-3">
                    <!--== Start widget Item ==-->
                    <div class="widget-item widget-services-item">
                        <h4 class="widget-title">Services</h4>
                        <h4 class="widget-collapsed-title collapsed" data-bs-toggle="collapse"
                            data-bs-target="#widgetId-1">Services</h4>
                        <div id="widgetId-1" class="collapse widget-collapse-body">
                            <div class="collapse-body">
                                <div class="widget-menu-wrap">
                                    <ul class="nav-menu">
                                        <li><a >Home monitoring</a></li>
                                        <li><a >Air Filters</a></li>
                                        <li><a >Professional installation</a></li>
                                        <li><a >Smart Buildings</a></li>
                                        <li><a >For contractors</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--== End widget Item ==-->
                </div>
                <div class="col-md-6 col-lg-3">
                    <!--== Start widget Item ==-->
                    <div class="widget-item widget-account-item">
                        <h4 class="widget-title">My Account</h4>
                        <h4 class="widget-collapsed-title collapsed" data-bs-toggle="collapse"
                            data-bs-target="#widgetId-2">My Account</h4>
                        <div id="widgetId-2" class="collapse widget-collapse-body">
                            <div class="collapse-body">
                                <div class="widget-menu-wrap">
                                    <ul class="nav-menu">
                                        <li><a >My Account</a></li>
                                        <li><a >Contact</a></li>
                                        <li><a >Shopping cart</a></li>
                                        <li><a >Shop</a></li>
                                        <li><a >Services Login</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--== End widget Item ==-->
                </div>
                <div class="col-md-6 col-lg-3">
                    <!--== Start widget Item ==-->
                    <div class="widget-item">
                        <h4 class="widget-title">Contact Info</h4>
                        <h4 class="widget-collapsed-title collapsed" data-bs-toggle="collapse"
                            data-bs-target="#widgetId-3">Contact Info</h4>
                        <div id="widgetId-3" class="collapse widget-collapse-body">
                            <div class="collapse-body">
                                <div class="widget-contact-wrap">
                                    <ul>
                                        <li><span>Address:</span> Your address goes here.</li>
                                        <li><span>Phone//fax:</span> <a href="tel://0123456789">0123456789</a></li>
                                        <li><span>Email:</span> <a href="mailto://demo@example.com">demo.com</a>
                                        </li>
                                        <li><a target="_blank" href="https://www.hasthemes.com">www.example.com</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--== End widget Item ==-->
                </div>
            </div>
        </div>
    </div>
    <!--== End Footer Main ==-->

    <!--== Start Footer Bottom ==-->
    <div class="footer-bottom">
        <div class="container pt--0 pb--0">
            <div class="row">
                <div class="col-md-7 col-lg-6">
                    <p class="copyright">© 2021 DNJ. Made with <i class="fa fa-heart"></i> by <a >SHIVAM.</a></p>
                </div>
           
            </div>
        </div>
    </div>
    <!--== End Footer Bottom ==-->
</footer>